module.exports = __webpack_public_path__ + "img/compatability-love.844d5056.jpg";